import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

window.addEventListener('DOMContentLoaded', () => {
   const wpEmbedEls = Array.from(document.querySelectorAll('.wp-embed'));
   wpEmbedEls.forEach(wpEmbedEl => {
      addGAtoAnyLink(wpEmbedEl);
   });
});

const addGAtoAnyLink = wpArticleEl => {
   const links = wpArticleEl.querySelectorAll('a');
   const slug = App.wpSlug;
   links.forEach(link => {
      link.addEventListener('click', () => {
         const eventLabel = `wpId-${slug}-clicked-${link.href}}`;
         trackInMatomoAndGA({
            eventCategory: 'Wordpress Page/Post',
            eventAction: 'click',
            eventName: eventLabel,
         });
      });
   });
};
